import { ref, computed, watch, onMounted } from 'vue'
import { useDashboardStore } from '@/stores/dashboard.store'
import { kpiVersion } from '@/composables/kpi-refresh'

const normalizeFilters = (filters) => {
  const pt = filters?.periodType
  return {
    warehouseIds: filters?.warehouseIds ?? [],
    periodType: (pt && pt !== 'all') ? pt : 'month',
    periodFrom: filters?.periodFrom ?? null,
    periodTo: filters?.periodTo ?? null,
  }
}

// Reactive value of a dashboard KPI metric: fetches on mount and whenever the key or the
// filters change, guarding against out-of-order responses. Shared by the dashboard KPI tile
// and the contextual signal bar.
export const useKpiMetricValue = (metricKeyGetter, filtersGetter = () => ({})) => {
  const dashboardStore = useDashboardStore()

  const value = ref(null)
  const loading = ref(true)

  const metric = computed(() => dashboardStore.kpiMetric(metricKeyGetter()))
  const activeFilters = computed(() => normalizeFilters(filtersGetter()))
  const activeFiltersKey = computed(() => JSON.stringify(activeFilters.value))

  let fetchSeq = 0
  const fetchData = async() => {
    if (!metric.value?.fetch) {
      value.value = null
      loading.value = false
      return
    }
    const seq = ++fetchSeq
    loading.value = true
    value.value = null
    const result = await metric.value.fetch(activeFilters.value)
    if (seq === fetchSeq) {
      value.value = result
      loading.value = false
    }
  }

  onMounted(fetchData)
  watch(metric, fetchData)
  watch(activeFiltersKey, fetchData)
  watch(kpiVersion, fetchData)

  return { value, loading, metric }
}
